import React, { useState } from "react";
import Webcam from "react-webcam";
import { Box, Button, IconButton, Typography } from "@mui/material";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import TagFacesIcon from "@mui/icons-material/TagFaces";
import PhotoFilterIcon from "@mui/icons-material/PhotoFilter";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import LandscapeIcon from "@mui/icons-material/Landscape";
import DownloadIcon from "@mui/icons-material/Download";
import { StoryWidget } from "./subirHistorias";

const StoryInitial = ({
  setImage,
  isMobile,
}: {
  setImage: (image: any) => void;
  isMobile: boolean;
}) => {
  const [camaraOn, setCamaraOn] = useState<boolean>(false);
  const webcamRef = React.useRef<any>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setImage(file);
    }
  };

  const captureImage = () => {
    const screenshot = webcamRef.current.getScreenshot();
    if (screenshot) {
      const byteString = atob(screenshot.split(",")[1]);
      const mimeString = screenshot.split(",")[0].split(":")[1].split(";")[0];

      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([arrayBuffer], { type: mimeString });
      const file = new File([blob], "captured_image.jpg", { type: mimeString });
      setImage(file);
    }
  };

  return (
    <>
      {camaraOn && (
        <>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            width="100%"
          />
          <IconButton
            aria-label="capture"
            onClick={captureImage}
            sx={{
              position: "absolute",
              bottom: 20,
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "white",
              borderRadius: "50%",
              width: 60,
              height: 60,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
              zIndex: 10,
            }}
          >
            <div
              style={{
                borderRadius: "50%",
                border: "4px solid #ff0000",
                width: "80%",
                height: "80%",
              }}
            />
          </IconButton>
        </>
      )}
      {!camaraOn && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Button
            variant="contained"
            onClick={() => setCamaraOn(true)}
            sx={{
              gap: "10px",
              backgroundColor: "grey",
              border: "1px solid black",
              "&:hover": {
                backgroundColor: "#d3d3d3",
              },
            }}
          >
            <AddAPhotoIcon />
            <Typography style={{ fontSize: isMobile ? "12px" : "14px" }}>
              Tomar una foto
            </Typography>
          </Button>
          <input
            type="file"
            accept="image/jpeg,image/png,image/jpg"
            style={{ display: "none" }}
            id="file-upload"
            onChange={handleFileChange}
          />
          <label htmlFor="file-upload">
            <Button
              variant="contained"
              sx={{
                gap: "10px",
                backgroundColor: "grey",
                border: "1px solid black",
                "&:hover": {
                  backgroundColor: "#d3d3d3",
                },
              }}
              component="span"
            >
              <LandscapeIcon />
              <Typography style={{ fontSize: isMobile ? "12px" : "14px" }}>
                Elegir desde galería
              </Typography>
            </Button>
          </label>
        </div>
      )}
    </>
  );
};

export default StoryInitial;